import React from 'react';
import { inject } from 'mobx-react';
import { AppPasswordRecoveryTemplate } from 'themes/modules/membership/pages';

@inject(i => ({
	viewStore: i.rootStore,
}))
export default class AppPasswordRecovery extends React.Component {
	render() {
		return <AppPasswordRecoveryTemplate {...this.props} />;
	}
}



// WEBPACK FOOTER //
// ./src/modules/membership/pages/AppPasswordRecovery.jsx